import CheckoutStep, { CheckoutStepModelProps } from '@/models/checkout/CheckoutStep';
import { PaymentMethod } from '@/models/payments';

// Step Data Props
export interface StepPaymentMethodDataProps {
	applyStoreCredit: boolean;
	paymentMethod: PaymentMethod | null;
	availableStoreCredit: number;
	noPaymentRequired: boolean;
}

// JS Model Props
export interface StepPaymentMethodModelProps extends CheckoutStepModelProps {
	data: Partial<StepPaymentMethodDataProps>;
}

// API Response Props
// No API props; data stored locally only

// Constructor Props
export type StepPaymentMethodCtorProps = StepPaymentMethodModelProps;

export default class StepPaymentMethod extends CheckoutStep {

	applyStoreCredit: boolean;
	paymentMethod: PaymentMethod | null;
	availableStoreCredit: number;
	noPaymentRequired: boolean;

	constructor(props: StepPaymentMethodCtorProps) {
		
		const mappedProps = StepPaymentMethod.mapStepDataToModel(props);

		super(props);

		this.applyStoreCredit = mappedProps.applyStoreCredit;
		this.paymentMethod = mappedProps.paymentMethod;
		this.availableStoreCredit = mappedProps.availableStoreCredit;
		this.noPaymentRequired = mappedProps.noPaymentRequired;
	}

	// Explicitly map API response to the internal model format
	private static mapStepDataToModel(props: StepPaymentMethodCtorProps): StepPaymentMethodDataProps {
				
		return {
			applyStoreCredit: props.data?.applyStoreCredit ?? false,
			paymentMethod: props.data?.paymentMethod ?? null,
			availableStoreCredit: props.data?.availableStoreCredit ?? 0,
			noPaymentRequired: props.data?.noPaymentRequired ?? false,
		};
	}
}